var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtgrStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 3.8969V18.5636H6.41665C5.93042 18.5636 5.4641 18.3704 5.12028 18.0266C4.77647 17.6828 4.58331 17.2165 4.58331 16.7302V5.73023C4.58331 5.244 4.77647 4.77768 5.12028 4.43387C5.4641 4.09005 5.93042 3.8969 6.41665 3.8969H17.4166Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 14.8969H6.41665C5.93042 14.8969 5.4641 15.0901 5.12028 15.4339C4.77647 15.7777 4.58331 16.244 4.58331 16.7302M8.24998 7.56357H13.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtgrStudent);
export default __webpack_public_path__ + "static/media/ctgr-student.f8cc563646d8d3139b97502ab7b75d44.svg";
export { ForwardRef as ReactComponent };